/**
 * Main Layout Component
 */

import React, { useEffect } from 'react';
import { Layout as AntLayout, Grid } from 'antd';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import LegalFooter from './LegalFooter';
import { useUIStore } from '../../stores';
import './Layout.css';

const { Content, Footer } = AntLayout;
const { useBreakpoint } = Grid;

const Layout: React.FC = () => {
  const { sidebarCollapsed, setSidebarCollapsed } = useUIStore();
  const screens = useBreakpoint(); // 반응형 훅 사용

  // 모바일 여부 (lg 미만이면 모바일로 간주)
  // useBreakpoint가 초기 로드 시 빈 객체를 반환할 수 있으므로 window.innerWidth와 병행 체크
  const isMobile = screens.lg === false || (Object.keys(screens).length === 0 && window.innerWidth < 992);

  useEffect(() => {
    if (isMobile && !sidebarCollapsed) {
      setSidebarCollapsed(true);
    }
  }, [isMobile, sidebarCollapsed, setSidebarCollapsed]);

  return (
    <AntLayout style={{ minHeight: '100vh' }}>
      <Sidebar
        collapsed={sidebarCollapsed}
        onCollapse={setSidebarCollapsed}
        isMobile={isMobile}
      />
      <AntLayout
        style={{
          marginLeft: isMobile ? 0 : (sidebarCollapsed ? 80 : 240),
          minWidth: 0,
          transition: 'margin-left 0.2s',
          minHeight: '100vh',
        }}
      >
        <Header />
        <Content
          className="app-content"
          style={{
            margin: '24px',
            padding: '24px',
            background: 'transparent',
            minHeight: 'calc(100vh - 64px - 48px)',
            borderRadius: '8px',
          }}
        >
          <Outlet />
        </Content>
        <Footer style={{ padding: 0, background: 'transparent' }}>
          <LegalFooter compact />
        </Footer>
      </AntLayout>
    </AntLayout>
  );
};

export default Layout;
